import type { IHeatmapMetaPayload, IHeatmapMetaStore } from '../../stores/heatmap-meta';

import { useHeatmapMetaStore } from '../../stores/heatmap-meta';
import { createViewContextHook } from '@gem-sdk/heatmap-react';

interface IHeatmapMetaState {
  meta: IHeatmapMetaPayload | undefined;
  getMeta: <K extends keyof IHeatmapMetaPayload>(key: K) => IHeatmapMetaPayload[K];
  rankQuery: string;
}

interface IHeatmapMetaActions {
  setMeta: <K extends keyof IHeatmapMetaPayload>(key: K, value: IHeatmapMetaPayload[K]) => void;
  setRankQuery: (query: string) => void;
  clearView: (viewId: string) => void;
}

export const useHeatmapMetaContext = createViewContextHook<
  IHeatmapMetaStore,
  IHeatmapMetaState,
  IHeatmapMetaActions
>({
  useStore: useHeatmapMetaStore,

  getState: (store, viewId) => ({
    meta: store.data.get(viewId),
    getMeta: (key) => store.data.get(viewId)?.[key],
    rankQuery: store.rankQuery.get(viewId) ?? '',
  }),

  getActions: (store, viewId) => ({
    setMeta: (key, value) => store.setMeta(key, value, viewId),
    setRankQuery: (query) => store.setRankQuery(query, viewId),
    clearView: (viewId) => store.clearView(viewId),
  }),
});
